import { render, staticRenderFns } from "./LegalApp.vue?vue&type=template&id=288b6f00&"
import script from "./LegalApp.vue?vue&type=script&lang=js&"
export * from "./LegalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports